// extracted by mini-css-extract-plugin
module.exports = {"wrapper__icon":"UserManagement_wrapper__icon__3S27n","wrapper__searchAndActionsContainer":"UserManagement_wrapper__searchAndActionsContainer__EDf0x"};